export default __webpack_public_path__ + "static/media/Cert.eeb40c0a.svg";